module.exports = (__webpack_require__(27546))(1871);